/**
 * English domain: Cambridge levels offered in the pilot (FR-02).
 *
 * Mirrors the `domain_levels` seed in
 * `supabase/migrations/20261031000002_learners_and_enrollment.sql`; the
 * server validates codes and ordering. Level codes belong to this domain
 * module, never to platform code (solution-architecture-v0.1 §5.2).
 */

export const ENGLISH_DOMAIN_CODE = 'english'

export interface LevelOption {
  readonly code: string
  readonly name: string
  readonly cefr: string
  readonly icon: string
  readonly sequence: number
}

export const ENGLISH_LEVELS: readonly LevelOption[] = [
  { code: 'MOV', name: 'Movers', cefr: 'A1', icon: '🚲', sequence: 1 },
  { code: 'FLY', name: 'Flyers', cefr: 'A2', icon: '🪁', sequence: 2 },
  { code: 'KET', name: 'A2 Key', cefr: 'A2', icon: '🔑', sequence: 3 },
]

export function englishLevel(code: string): LevelOption | undefined {
  return ENGLISH_LEVELS.find((l) => l.code === code)
}

/** A target level may not be below the current level. */
export function isValidTarget(currentCode: string, targetCode: string): boolean {
  const current = englishLevel(currentCode)
  const target = englishLevel(targetCode)
  return (
    current !== undefined && target !== undefined && target.sequence >= current.sequence
  )
}
